import { createFileRoute, Navigate } from '@tanstack/react-router';

import { useOrganizationContext } from '@apps/web/context/organization_provider';

export const Route = createFileRoute('/_app/(main)/')({
    component: MainIndexRoute,
});

function MainIndexRoute() {
    const {
        organizationId,
        memberships,
        isLoading: isLoadingOrganizationContext,
    } = useOrganizationContext();

    if (isLoadingOrganizationContext) {
        return null;
    }

    if (organizationId === null && memberships.length > 0) {
        return null;
    }

    return (
        <Navigate
            to="/home"
            // Forward search params, narrowing `view` to the values the home
            // route accepts (other routes use `view` for their own filters).
            search={(prev) => ({
                ...prev,
                view: prev.view === 'checklist' ? prev.view : undefined,
                automation_id:
                    typeof prev.automation_id === 'string'
                        ? prev.automation_id
                        : undefined,
            })}
            replace={true}
        />
    );
}
